import React, { useEffect, useRef, useState } from "react";
import { getValidAllarmeteo } from "../../services/allarmeteoService.js";
import { FaArrowLeft, FaArrowRight, FaRegSmile } from "react-icons/fa";
import { useAuth } from "../../contexts/AuthContextProvider.jsx";
import { getValidAlerts } from "../../services/alertsService.js";
import AlertCard from "./AlertCard.jsx";
import Skeleton from "react-loading-skeleton";

function AlertsSwiperCard({ mode }) {
	const [alerts, setAlerts] = useState(null);
	const [currentIndex, setCurrentIndex] = useState(0);
	const pauseScroll = useRef(false);
	const { user } = useAuth();

	useEffect(() => {
		const fetchData = () => {
			if (mode === "allarmeteo")
				getValidAllarmeteo().then((response) => setAlerts(response.data.allarmeteo));
			else if (mode === "comune")
				getValidAlerts().then((response) => setAlerts(response.data.alerts));
		};
		fetchData();
		const interval = setInterval(fetchData, 5 * 60 * 1000);
		return () => clearInterval(interval);
	}, [mode]);

	useEffect(() => {
		const interval = setInterval(() => {
			if (!pauseScroll.current)
				setCurrentIndex((prevIndex) => (prevIndex + 1) % alerts.length);
		}, 10000);
		return () => clearInterval(interval);
	}, [alerts]);

	const handleNext = () => setCurrentIndex((prevIndex) => (prevIndex + 1) % alerts.length);
	const handlePrevious = () =>
		setCurrentIndex((prevIndex) => (prevIndex === 0 ? alerts.length - 1 : prevIndex - 1));

	if (!alerts) {
		return (
			<div className="p-4 flex flex-col items-center h-full">
				<div className="w-full h-full">
					<Skeleton height={"100%"} />
				</div>
			</div>
		);
	}

	return (
		<div className="w-full  flex flex-col items-center justify-between ">
			{/* Card dell'allerta */}
			{alerts.length > 0 && (
				<AlertCard
					key={alerts[currentIndex].id}
					pauseScroll={pauseScroll}
					alert={alerts[currentIndex]}
					isAuthenticated={user !== null}
					mode={mode}
					style={{ height: alerts.length > 1 ? "290px" : "340px" }}
				/>
			)}

			{alerts.length > 1 && (
				<div className="flex justify-between items-center w-full max-w-lg mt-4 gap-2">
					<button
						id="left"
						aria-label="Scorri indietro"
						onClick={handlePrevious}
						className="text-gray-500 hover:text-gray-700"
					>
						<FaArrowLeft size={24} />
					</button>

					<div className="flex justify-center gap-2">
						{alerts.map((_, index) => (
							<span
								key={index}
								className={`w-3 h-3 rounded-full ${
									index === currentIndex ? "bg-blue-500" : "bg-gray-300"
								}`}
							></span>
						))}
					</div>

					<button
						id="right"
						aria-label="Scorri avanti"
						onClick={handleNext}
						className="text-gray-500 hover:text-gray-700"
					>
						<FaArrowRight size={24} />
					</button>
				</div>
			)}

			{alerts.length === 0 && (
				<div className="flex flex-col items-center justify-center w-full max-w-lg space-y-2">
					<h2 className="pt-3 text-xl font-bold text-center w-full">
						{mode === "allarmeteo" && "Allerte Regionali"}
						{mode === "comune" && "Allerte Comunali"}
					</h2>

					<div className="flex flex-col justify-center items-center h-[130px]">
						<p className="text-gray-700 text-4xl mb-4">
							<FaRegSmile />
						</p>
						<p className="text-gray-700 text-center pb-0">Nessuna allerta presente.</p>
					</div>
				</div>
			)}
		</div>
	);
}

export default AlertsSwiperCard;
